var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"loan-application-page"},[(!_vm.loanApplication.success)?_c('loan-application-info',{attrs:{"title":"Lo sentimos","message":_vm.loanApplication.message,"message-type":"error"}}):_c('loan-applicacion-step-handler')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }